import {useSettingsQuery} from '../../../common/providers/ApiInterface'

export const useAreaTypeId = (areaCode?: string) => {
  return useSettingsQuery('upmAreaTypes', [], {
    gcTime: 0,
    retry: false,
    staleTime: 0,
    enabled: !!areaCode,
    select: (data) => data.find((type) => type.code === areaCode)?.id
  })
}

export const QueryKey = 'upmAreaTypes'
